module.exports = __webpack_public_path__ + "img/full-screen.2d8292b1.svg";